"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreDocumentUploadStepQueryAllOfToJSON = exports.PreDocumentUploadStepQueryAllOfFromJSONTyped = exports.PreDocumentUploadStepQueryAllOfFromJSON = void 0;
const _1 = require("./");
function PreDocumentUploadStepQueryAllOfFromJSON(json) {
    return PreDocumentUploadStepQueryAllOfFromJSONTyped(json, false);
}
exports.PreDocumentUploadStepQueryAllOfFromJSON = PreDocumentUploadStepQueryAllOfFromJSON;
function PreDocumentUploadStepQueryAllOfFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'uploadedFiles': (json['uploadedFiles'].map(_1.DocumentMetaFromJSON)),
    };
}
exports.PreDocumentUploadStepQueryAllOfFromJSONTyped = PreDocumentUploadStepQueryAllOfFromJSONTyped;
function PreDocumentUploadStepQueryAllOfToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'uploadedFiles': (value.uploadedFiles.map(_1.DocumentMetaToJSON)),
    };
}
exports.PreDocumentUploadStepQueryAllOfToJSON = PreDocumentUploadStepQueryAllOfToJSON;
//# sourceMappingURL=PreDocumentUploadStepQueryAllOf.js.map